import {
	GraduationCap, Megaphone, Network, Building2, Baby,
	TrendingUp, Sparkles, MonitorSmartphone,
} from "lucide-react";

export const SERVICES = [
	{
		id: "school-admissions",
		title: "School Admissions",
		badge: "100% Guaranteed*",
		icon: GraduationCap,
		tagline: "Fill every seat, every session.",
		requirement: "Increase School Admissions",
		sourcePage: "School Admissions",
		desc: "End-to-end admission acceleration, lead conversion funnels & counsellor training.",
		points: [
			"Catchment-area parent targeting within 5–15 km",
			"High-converting enquiry & counselling funnels",
			"Counsellor scripts, training & follow-up systems",
			"Admission event & open-house campaigns",
		],
		outcome: "Schools working with us see 30–60% more qualified admission enquiries per session.",
	},
	{
		id: "school-marketing",
		title: "School Marketing",
		badge: "High ROI",
		icon: Megaphone,
		tagline: "Be the school every parent talks about.",
		requirement: "School Marketing",
		sourcePage: "School Marketing",
		desc: "Omnichannel campaigns targeting parents in your catchment area.",
		points: [
			"Hyper-local Meta & Google Ads",
			"Creative, video & reputation content",
			"WhatsApp & lead-nurture automation",
			"Monthly performance reporting",
		],
		outcome: "A predictable, always-on enquiry pipeline instead of seasonal panic.",
	},
	{
		id: "school-franchise",
		title: "School Franchise",
		badge: "Scale Fast",
		icon: Network,
		tagline: "Turn your brand into a network.",
		requirement: "School Franchise",
		sourcePage: "School Franchise",
		desc: "Turnkey franchise modeling, partner recruitment & institutional expansion.",
		points: [
			"Franchise business & royalty modeling",
			"Partner recruitment campaigns",
			"Brand playbooks & SOPs",
			"Multi-unit launch support",
		],
		outcome: "A repeatable expansion engine to grow from one campus to many.",
	},
	{
		id: "new-school-setup",
		title: "New School Setup",
		badge: "Concept to Launch",
		icon: Building2,
		tagline: "From blueprint to first bell.",
		requirement: "New School Setup",
		sourcePage: "New School Setup",
		desc: "Feasibility, CBSE/ICSE affiliation guidance, curriculum & infrastructure roadmap.",
		points: [
			"Feasibility & catchment study",
			"Affiliation & compliance roadmap",
			"Curriculum, staffing & infra planning",
			"Pre-launch admission campaign",
		],
		outcome: "Launch with clarity, compliance and a full first batch.",
	},
	{
		id: "preschool-setup",
		title: "Preschool Setup",
		badge: "50 Admissions Assured*",
		icon: Baby,
		tagline: "Open your doors to a full nursery.",
		requirement: "Preschool Setup",
		sourcePage: "Preschool Setup",
		desc: "Complete preschool ecosystem design, branding & guaranteed launch intake.",
		points: [
			"Brand identity & classroom design",
			"Curriculum & teacher onboarding",
			"Local launch marketing blitz",
			"50 admissions assured for launch*",
		],
		outcome: "Start day one with a full batch and a premium local reputation.",
	},
	{
		id: "school-growth-management",
		title: "School Growth & Management",
		badge: "Turnaround",
		icon: TrendingUp,
		tagline: "Fix the leaks. Build the momentum.",
		requirement: "School Growth & Management",
		sourcePage: "School Growth",
		desc: "Operational optimization, fee structuring & academic reputation management.",
		points: [
			"Retention & re-enrolment systems",
			"Fee structuring & revenue planning",
			"Staff & academic quality frameworks",
			"Reputation & review management",
		],
		outcome: "Stabilise operations and return the institution to healthy growth.",
	},
	{
		id: "school-branding",
		title: "School Branding",
		badge: "Premium Identity",
		icon: Sparkles,
		tagline: "Look like the school parents aspire to.",
		requirement: "School Branding",
		sourcePage: "School Branding",
		desc: "Positioning your school as the top choice for discerning parents.",
		points: [
			"Logo, identity & prospectus design",
			"Website & digital presence",
			"Positioning & messaging strategy",
			"Signage & campus experience",
		],
		outcome: "A premium brand that commands trust and higher fees.",
	},
	{
		id: "digital-marketing",
		title: "Digital Marketing",
		badge: "360° Digital",
		icon: MonitorSmartphone,
		tagline: "Own every screen in your city.",
		requirement: "Digital Marketing",
		sourcePage: "Digital Marketing",
		desc: "Hyper-local SEO, Google Ads, Meta Ads & WhatsApp automation for school leads.",
		points: [
			"Local SEO & Google Business ranking",
			"Performance ad campaigns",
			"Landing pages & lead capture",
			"WhatsApp & CRM automation",
		],
		outcome: "More qualified digital enquiries at a lower cost per lead.",
	},
];

export const SCHOOL_TYPES = [
	"Preschool / Playschool",
	"K-12 School",
	"CBSE",
	"ICSE",
	"State Board",
	"International / IB",
	"New / Upcoming School",
	"Franchise",
	"Other",
];

export const STUDENT_STRENGTHS = [
	"Not launched yet",
	"Under 100",
	"100 – 300",
	"300 – 600",
	"600 – 1000",
	"1000+",
];

export const CALL_TIMES = [
	"Anytime",
	"Morning (9 AM – 12 PM)",
	"Afternoon (12 PM – 4 PM)",
	"Evening (4 PM – 8 PM)",
];
